import { graphql } from '@/gql';
import type { Partner, PartnerLocation } from '../partners';
import type { MasterAnyType, MasterWorkPlace } from './types';

export const mapMasterToPartnerMasterFragment = graphql(/** GraphQL */ `
  fragment MapMasterToPartner_MasterFragment on Master {
    id
    slug
    fullName

    ...SocialFields
  }
`);

export function mapWorkPlaceToPartnerLocation(
  workPlace: MasterWorkPlace
): PartnerLocation {
  return {
    ...workPlace,
    workPlaceId: workPlace.id,
    name: workPlace.name ?? workPlace.address,
    href: workPlace.companyId ? `/companies/${workPlace.companyId}` : undefined,
  };
}

export function mapMasterToPartner(master: MasterAnyType): Partner {
  return {
    ...master,
    name: master.fullName,
    link: {
      name: 'Partner details',
      params: {
        city: master.workPlaces?.[0]?.city,
        type: 'masters',
        partner: master.slug,
      },
    },
    yearsOfExperience: null,
    locations: (master.workPlaces ?? []).map((workPlace) =>
      mapWorkPlaceToPartnerLocation(workPlace)
    ),
    instagramProfile: master.instagramProfile ?? undefined,
    telegramProfile: master.telegramProfile ?? undefined,
    whatsappProfile: master.whatsappProfile ?? undefined,
    youtubeProfile: master.youtubeProfile ?? undefined,
    vkProfile: master.vkProfile ?? undefined,
    odnoklassnikiProfile: master.odnoklassnikiProfile ?? undefined,
    personalSite: master.personalSite ?? undefined,
    phone: master.phone ?? undefined,
    email: master.email ?? undefined,
  };
}
